import { Location } from '@angular/common';
import { Component, OnInit } from "@angular/core";
import moment from 'moment';
import { AuthService } from "../../../seguranca/auth.service";

@Component({
  standalone: false,
  selector: "analise",
  templateUrl: "./analise-repasse.component.html"
})
export class AnaliseRepasseComponent implements OnInit {

  repasse;
  periodoInicial;
  periodoFinal;

  relatorioVisitaInLoco: boolean = false;
  parecerTecnicoPrestacaoContas: boolean = false;
  relatorioTecnicoMonitoramentoAvaliacao: boolean = false;
  analiseFinanceira: boolean = false;
  outrasPendencias: boolean = false;

  relatorioPrestacaoContas: boolean = false;
  relatorioReceitaDespesa: boolean = false;
  relatorioPagamentosEfetuados: boolean = false;
  relatorioNotasComprovantes: boolean = false;
  relatorioOrdemBancariaComprovanteTransferencia: boolean = false;
  relatorioCotacaoPreco: boolean = false;
  relatorioExtratoBancario: boolean = false;

  constructor(
    public auth: AuthService,
    private location: Location
  ) { }


  ngOnInit() {
    this.repasse = JSON.parse(sessionStorage.getItem("repasse"));

    this.periodoInicial = moment(this.repasse.obDataTransf).format("YYYY-MM-DD")
    // Demanda 5272, item 2 (Redmine): o fim do periodo de analise passa a ser a
    // data em que o proponente enviou a prestacao de contas para analise
    // (Financeiro.dataSolicitacaoAnalise), nao mais "hoje". Sem essa data (repasse
    // legado ainda nao enviado), mantem o comportamento anterior como fallback.
    this.periodoFinal = moment(this.repasse.dataSolicitacaoAnalise || undefined).format("YYYY-MM-DD")
  }

  goBack() {
    this.location.back();
  }

  closeOthers(item) {
    this.relatorioVisitaInLoco = false;
    this.parecerTecnicoPrestacaoContas = false;
    this.relatorioTecnicoMonitoramentoAvaliacao = false;
    this.analiseFinanceira = false;
    this.outrasPendencias = false;

    if (item === 0) this.relatorioVisitaInLoco = true;
    if (item === 1) this.parecerTecnicoPrestacaoContas = true;
    if (item === 2) this.relatorioTecnicoMonitoramentoAvaliacao = true;
    if (item === 3) this.analiseFinanceira = true;
    if (item === 4) this.outrasPendencias = true;
  }

}